/* 🧩 COMPONENTS */
import { Popover } from "../../Components";

/* 🔧 UTILS */
import { handleProfilePrevStep, handleProfileNextStep } from "./profile";
import { handleMapPrevStep, handleMapNextStep } from "./map";
import { handleDashboardPrevStep, handleDashboardNextStep } from "./dashboard";
import { handleControlPrevStep, handleControlNextStep } from "./control";
import { handleComparePrevStep, handleCompareNextStep } from "./compare";
import { handleHistoryPrevStep, handleHistoryNextStep } from "./history";

const removeEquipmentMarker = () => {
  const marker = document.querySelector('#equipment-marker');
  marker && marker.remove();
}

const handleClose = (setIsOpen, setCurrentStep, customClose) => {
  removeEquipmentMarker();
  customClose?.();
  setIsOpen(false);
  setCurrentStep(0);
};

export const createStep = ({ selector, stepNumber, titleKey, textKey, customClose, position, children }) => ({
  selector,
  content: ({ setIsOpen, setCurrentStep }) => (
    <Popover
      stepNumber={stepNumber}
      title={titleKey}
      text={textKey}
      onClose={() => handleClose(setIsOpen, setCurrentStep, customClose)}
      >
      {children?.(setIsOpen)}
    </Popover>
  ),
  position: position,
});

export const tourConfig = () => [
  {
    match: (path) => path === '/',
    next: (currentStep, setCurrentStep, setIsOpen) =>
      handleMapNextStep(currentStep, setCurrentStep, setIsOpen),
    prev: (currentStep, setCurrentStep, setIsOpen) =>
      handleMapPrevStep(currentStep, setCurrentStep, setIsOpen),
  },
  {
    match: (path) => path === '/perfil',
    next: (currentStep, setCurrentStep, setIsOpen) =>
      handleProfileNextStep(currentStep, setCurrentStep, setIsOpen),
    prev: (currentStep, setCurrentStep, setIsOpen) =>
      handleProfilePrevStep(currentStep, setCurrentStep, setIsOpen),
  },
  {
    match: (path) => /^\/perfil\/[0-9a-fA-F-]{36}$/.test(path), 
    next: (currentStep, setCurrentStep, setIsOpen) => 
      currentStep === 2 ? (setCurrentStep(0), setIsOpen(false)) : setCurrentStep(currentStep + 1),
    prev: (currentStep, setCurrentStep) =>
      currentStep > 0 && setCurrentStep(currentStep - 1)
  },
  {
    match: (path) => /^\/dashboard\/[A-Za-z0-9-]+$/i.test(path),
    next: (currentStep, setCurrentStep, setIsOpen) =>
      handleDashboardNextStep(currentStep, setCurrentStep, setIsOpen),
    prev: (currentStep, setCurrentStep, setIsOpen) =>
      handleDashboardPrevStep(currentStep, setCurrentStep, setIsOpen),
  },
  {
    match: (path) => /^\/controle\/[A-Za-z0-9-]+$/i.test(path),
    next: (currentStep, setCurrentStep, setIsOpen) =>
      handleControlNextStep(currentStep, setCurrentStep, setIsOpen),
    prev: (currentStep, setCurrentStep, setIsOpen) =>
      handleControlPrevStep(currentStep, setCurrentStep, setIsOpen),
  },
  {
    match: (path) => path === '/historico/graphs',
    next: (currentStep, setCurrentStep, setIsOpen) =>
      handleCompareNextStep(currentStep, setCurrentStep, setIsOpen),
    prev: (currentStep, setCurrentStep, setIsOpen) =>
      handleComparePrevStep(currentStep, setCurrentStep, setIsOpen),
  },
  {
    match: (path) => /^\/historico\/[A-Za-z0-9-]+$/i.test(path),
    next: (currentStep, setCurrentStep, setIsOpen) =>
      handleHistoryNextStep(currentStep, setCurrentStep, setIsOpen),
    prev: (currentStep, setCurrentStep, setIsOpen) =>
      handleHistoryPrevStep(currentStep, setCurrentStep, setIsOpen),
  },
];